import { useInRole } from '@/auth/useinrole';
import * as React from 'react';
import { ReactElement } from 'react';

export const PermWrapper = (props: {
	allowedRoles: string[];
	children?: React.ReactElement;
	fallback?: React.ReactElement;
}): ReactElement | null => {
	const hasPerms = useInRole(props.allowedRoles);
	if (!hasPerms) return props.fallback ?? null;
	return props.children || null;
};
